export function loginUser(state, action) {
  const userLoggedIn = true;

  const firstName =
    (action.data && action.data.detail && action.data.detail.profile && action.data.detail.profile.firstName) || null;
  const lastName =
    (action.data && action.data.detail && action.data.detail.profile && action.data.detail.profile.lastName) || null;
  const gameData =
    (action.data && action.data.detail && action.data.detail.data && action.data.detail.data.gameData4) || null;
  const appInitiatedLogin =
    (action.data && action.data.appInitiatedLogin) || false;
  console.log("user action.data", action.data);
  return {
    ...state,
    userLoggedIn,
    appInitiatedLogin,
    user: {
      firstName,
      lastName,
      gameData
    }
  };
}

export function logoutUser(state, action) {
  const userLoggedIn = false;
  const user = null;
  return {
    ...state,
    userLoggedIn,
    user,
  };
}



// WEBPACK FOOTER //
// ./src/js/reducers/user.js